<div class="dropdown" [class.is-active]="isOpen">
  <div class="dropdown-trigger">
    <button
      [attr.aria-expanded]="isOpen"
      class="button is-chip is-size-7-mobile"
      [class.is-applied]="getValues().length"
      [class.is-active]="isOpen"
      data-e2e="payment-type-filter-button-open"
      (click)="itemToggled.emit()"
      type="button"
      title="Payment type"
      i18n-title
    >
      <span>
        <span i18n>Payment type</span>
        <span *ngIf="showSelectedEntities.size"> (+{{ showSelectedEntities.size }}) </span>
      </span>
      <span class="icon">
        <i class="fas fa-chevron-down"></i>
      </span>
    </button>
  </div>

  <div class="dropdown-menu is-large">
    <div class="dropdown-content multi-select-filter">
      <div class="dropdown-item">
        <div
          class="is-flex is-flex-direction-row is-align-items-center is-justify-content-flex-end"
        >
          <button
            class="button is-text has-text-link is-small mb-1"
            data-e2e="button-select-all-filter"
            (click)="onSelectAll()"
            (keydown.enter)="onSelectAll()"
            type="button"
            title="Select All"
            i18n-title
            i18n
          >
            Select All
          </button>
        </div>
        <portal-search-filter-autocomplete-input
          #paymentSearchInput
          [searchInputValue]="searchedText"
          (search)="onSearch($event)"
        ></portal-search-filter-autocomplete-input>
      </div>

      <hr class="dropdown-divider" />

      <ng-container *ngIf="showSelectedEntities?.size">
        <div class="dropdown-item is-scrollable">
          <label class="label" i18n>Selected</label>
          <ng-container *ngFor="let entity of showSelectedEntities | keyvalue">
            <portal-search-filter-checkbox
              [id]="entity.key"
              [text]="entity.value.text"
              [selectedEntities]="localPreSelectedEntities"
              (removed)="onEntityRemoved($event)"
              (added)="onEntityAdded($event)"
              #preSelectedEntities
            ></portal-search-filter-checkbox>
          </ng-container>
        </div>
      </ng-container>

      <hr class="dropdown-divider" />

      <div class="dropdown-item is-scrollable">
        <ng-container *ngFor="let processorType of entities">
          <portal-search-filter-checkbox
            [id]="processorType.id"
            [text]="processorType.text"
            [selectedEntities]="localPreSelectedEntities"
            (added)="onEntityAdded(processorType)"
            (removed)="onEntityRemoved(processorType)"
          >
          </portal-search-filter-checkbox>
        </ng-container>
      </div>

      <hr class="dropdown-divider" />

      <div class="dropdown-item is-flex is-justify-content-space-between">
        <button
          class="button is-outlined"
          data-e2e="button-clear-filter"
          i18n
          (click)="onFilterClear()"
          (keydown.enter)="onFilterClear()"
          type="button"
          title="Clear"
          i18n-title
        >
          Clear
        </button>
        <button
          class="button is-primary ml-2"
          data-e2e="payment-type-filter-button-apply"
          i18n
          (click)="onFilterApplied()"
          (keydown.enter)="onFilterApplied()"
          type="button"
          title="Apply"
          i18n-title
        >
          Apply
        </button>
      </div>
    </div>
  </div>
</div>
